import script from "./PreSportsBetBoosts.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsBetBoosts.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsBetBoosts.vue?vue&type=style&index=0&id=0d8424ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8424ea"]])

export default __exports__